module.exports = __webpack_public_path__ + "static/media/load_repayment_2.63e90fb9.svg";